import React, { useEffect, useRef, useState } from 'react';
import { OpenInDesktopMessage } from 'shared/components/ui/open-in-desktop-message';
import { useStoredBoolean } from 'shared/hooks/use-stored-boolean';
import {
  clearPendingDesktopLaunch,
  getPendingDesktopLaunch,
  openInDesktopAppKey,
} from 'shared/services/local-storage';
import { getDesktopDownload } from 'shared/utils/get-desktop-download';
import { getOpenInAppTarget } from 'shared/utils/get-open-in-app-target';

export const OpenInDesktopGate: React.FC = () => {
  const [pendingLink, setPendingLink] = useState(getPendingDesktopLaunch);
  const [desktopDownload] = useState(getDesktopDownload);
  const [alwaysOpen, setAlwaysOpen] = useStoredBoolean(openInDesktopAppKey);
  const [autoLaunch] = useState(
    () => alwaysOpen && pendingLink !== null && !!desktopDownload,
  );
  const [isLaunched, setIsLaunched] = useState(autoLaunch);
  const consumedRef = useRef(false);

  const desktopUrl =
    pendingLink === null ? null : getOpenInAppTarget(pendingLink).desktopUrl;

  const handleOpen = () => setIsLaunched(true);
  const handleDismiss = () => setPendingLink(null);

  useEffect(() => {
    if (pendingLink === null || consumedRef.current) {
      return;
    }
    consumedRef.current = true;
    clearPendingDesktopLaunch();
    if (autoLaunch && desktopUrl) {
      window.location.assign(desktopUrl);
    }
  }, [autoLaunch, desktopUrl, pendingLink]);

  if (pendingLink === null || !desktopDownload || !desktopUrl) {
    return null;
  }

  return (
    <OpenInDesktopMessage
      desktopUrl={desktopUrl}
      downloadUrl={desktopDownload.url}
      platform={desktopDownload.platform}
      isLaunched={isLaunched}
      alwaysOpen={alwaysOpen}
      onOpen={handleOpen}
      onAlwaysOpenChange={setAlwaysOpen}
      onDismiss={handleDismiss}
    />
  );
};
